import { WithStyles, withStyles } from '@mui/styles';

import { muiStyles } from './styles';
import { UnauthorizedFirm } from './unauthorizedFirm';

export interface UnauthorizedFirmProps extends WithStyles<typeof muiStyles> {
    location: any;
}

export default withStyles(muiStyles)(UnauthorizedFirm);